<template>
<v-responsive>
    <v-data-table :items="sellers" :headers="headers" hide-default-footer>
        <template v-slot:item.companyName="{item}">
            {{ item.companyName[$i18n.locale] }}
        </template>
        <template v-slot:item.ceoName="{item}">
            {{ item.ceoName[$i18n.locale] }}
        </template>
        <template v-slot:item.category="{item}">
            {{ categories.find(({ _id }) => _id == item.category).name[$i18n.locale] }}
        </template>
        <template v-slot:item.introductions="{item}">
            <v-row justify="center">
                <v-col v-for="(introduction, index) in item.introductions" :key="index" cols="auto" class="pa-0 pr-2">
                    <v-icon v-if="introduction[$i18n.locale]" color="primary" @click="download(introduction[$i18n.locale])">{{ mdiArrowDownThinCircleOutline }}</v-icon>
                </v-col>
            </v-row>
        </template>
    </v-data-table>

    <pagination-component v-model="page" :count="pageCount" @input="search" class="mt-3"></pagination-component>
</v-responsive>
</template>
<script>
import api from "@/api";
import download from "downloadjs";
import { mdiArrowDownThinCircleOutline } from '@mdi/js';

import PaginationComponent from "../control/pagination-component.vue";
export default {
    components: {
        PaginationComponent
    },
    props: ["_fair"],
    data(){
        return {
            mdiArrowDownThinCircleOutline,

            page: 1,
            pageCount: 0,
            limit: 10,

            sellers: [],

            filter: {
                ...this.$attrs
            },

            categories: [],

            headers: [
                { text: "업체명", align: "center", value: "companyName" },
                { text: "대표자이름", align: "center", value: "ceoName" },
                { text: "카테고리", align: "center", value: "category" },
                { text: "주소", align: "center", value: "companyAddress" },
                { text: "회사소개서", align: "center", value: "introductions" },
            ]
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        download,
        async init(){
            let { categories } = await api.v1.shop.categories.gets({ params: { depth: 1 } });
            this.categories = categories;

            await this.search();
        },
        async search(){
            let { summary, sellers } = await api.v1.fairs.sellers.gets(this.$props._fair, {
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });

            this.pageCount = Math.ceil(summary.totalCount / this.limit);
            this.sellers = sellers;
        }
    }
}
</script>